import axios from 'axios'
import _ from "lodash";

export default {
    data() {
        return {
            isCollective: false,
            selected: [],
            collectiveLoading: false,
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    methods: {
        onCollective() {
            this.collectiveLoading = true;
            this.selectedAggaranId = null;
            this.fetchUsageList().then(res => {
                this.isCollective = true;
                // this.EnCommission = true;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                    this.formCollective.setFieldsValue({
                        iscommision: "1",
                        without_note: "0",
                    });
                });
                this.collectiveLoading = false
            })
        },
        handleCloseCollective() {
            this.fetchUsageList()
            this.isCollective = false;
            this.selected = [];
            this.formCollective.resetFields();
        },
        handleCheck(e) {
            const item = e.target.value;
            this.selected.filter(obj => obj.id == item.id).length == 0 ? this.selected.push(item) : this.selected.splice(this.selected.findIndex(obj => obj.id == item.id), 1)
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].elm.textContent
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        handleSet() {
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.displayMessage("form-warning");
                    return;
                }
                let data = {}
                if (this.type == 'revised') {
                    data = {
                        "id_laporan": (this.id || this.id_draft),
                        "kode_anggaran": values.kode_anggaran.split(';')[1],
                        "selected_item": this.selected,
                        "iscommision": values.iscommision,
                        "without_note": "1"
                    }
                } else {
                    data = {
                        "id_laporan": (this.id || this.id_draft),
                        "kode_anggaran": values.kode_anggaran.split(';')[1],
                        "selected_item": this.selected,
                        "iscommision": values.iscommision,
                        "without_note": "1"
                    }
                }

                this.loading.setCollective = true
                axios({
                    method: "put",
                    url: this.type == 'revised' ? this.$serviceUrl + "klaim_tiket/revisi_dtl_draft_kolektif" : this.$serviceUrl + "klaim_tiket/dtl_draft_kolektif",
                    processData: false,
                    data: data,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": this.getAuth.apikey,
                    },
                }).then(() => {
                    this.fetchUsageList();
                    this.formCollective.resetFields();
                    // this.EnCommission=true;
                    this.Viwithout_note=true;
                    this.selected = [];
                    this.checkAllCollective = false;
                    this.searchCollective = '';
                    this.loading.setCollective = false
                    this.displayMessage("success-save");
                }).catch(err => {
                    this.loading.setCollective = false
                    this.displayMessageValue("basic-error", err.response.data.message)
                })
            })
        },
        handleOptionCommission(val){
        if(val.target.value=="1"){
            this.Viwithout_note = false;
        }else{
            this.Viwithout_note = true;
        }
        this.$nextTick(function () {
            this.formCollective.setFieldsValue({
                without_note: "0",
            });
            });
        },
        onCheckAllChange(val){
        this.reportingCalc.forEach((element) => {
            if(element.edit_hapus!='0'){
            let index = _.findIndex(
                this.selected,
                (e) => {
                return e.id == element.id;
                }
            );

            if(val.target.checked){
                if(index < 0){
                this.selected.push(element)
                }
            }else{
                if(index >= 0){
                this.selected = _.filter(this.selected, (e) => e.id!=element.id)
                }
            }
            }
        })
        },
        onSearchCollective(){
        if (this.timer.collective) {
            clearTimeout(this.timer.collective);
            this.timer.collective = null;
        }
            this.timer.collective = setTimeout(() => {
            this.timer.loading = true;
            this.checkAllCollective = false;
            this.timer.loading = false;
        }, 600);
        },
        handlechangeCostCenter(val){
        this.peruntukan_list = val ? _.filter(this.baseData.peruntukan, item=>item.anggaran_id==val) : [];
        this.$nextTick(function () {
            this.formCollective.setFieldsValue({
            peruntukan: undefined,
            kode_anggaran: undefined
            });
        });
        },
        filterTreeNode(input, option) {
        return (
            option.data.props.texttitle == undefined ||
            (option.data.props.texttitle ? option.data.props.texttitle : "")
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0 ||
            (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
        },
        handlechangePeruntukan(val){
        const vinput = this.formCollective.getFieldsValue();
        
        const origin_ = {
            anggaran_id: vinput.cost_center,
            peruntukan_id: val
        }
        this.$nextTick(function () {
            this.formCollective.setFieldsValue({
            kode_anggaran: undefined
            });
        });
        Event.$emit("treeAggTraveloka", origin_);
        },
    }
}